import { render, staticRenderFns } from "./navTitle.vue?vue&type=template&id=464ea978&scoped=true"
import script from "./navTitle.vue?vue&type=script&lang=js"
export * from "./navTitle.vue?vue&type=script&lang=js"
import style0 from "./navTitle.vue?vue&type=style&index=0&id=464ea978&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "464ea978",
  null
  
)

export default component.exports